module.exports = __webpack_public_path__ + "static/media/Beu-Marketplace1.2287b43b.png";